const STATE_KEY = 'vuex-state'

export default (options) => (store) => {
  let rawStoredState = localStorage[STATE_KEY]

  // Restaura o estado dos módulos que utilizam storage
  if (rawStoredState) {
    let storedState = JSON.parse(rawStoredState)
    options.modules.forEach(mod => {
      store.commit(`${mod}/REPLACE_STATE`, storedState)
    })
  }

  return store.subscribe((mutation, state) => {
    if (options.destroyOn && options.destroyOn.includes(mutation.type)) {
      return localStorage.removeItem(STATE_KEY)
    }

    const newState = options.storedKeys.reduce((map, key) => {
      let split = key.split('/')
      if (split.length === 2) {
        let state = store.state[split[0]]
        map[key] = state[split[1]]
        return map
      }
      if (split.length === 1) {
        map[key] = store.state[split[0]]
        return map
      }
    }, {})

    localStorage[STATE_KEY] = JSON.stringify(newState)
  })
}
